
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';
import { ThemeProvider } from './contexts/ThemeContext';
import { SearchProvider } from './contexts/SearchContext';
import { Layout } from './components/Layout';
import { SEO } from './components/SEO';
import { ScrollToTop } from './components/ScrollToTop';
import { PerformanceOptimizer } from './components/PerformanceOptimizer';
import { HomePage } from './pages/HomePage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
import { SitemapPage } from './pages/SitemapPage';
import { useLanguageRouter } from './utils/i18nRouter';
import { RedirectFix } from './components/RedirectFix';

function App() {
  // 确保默认语言为英文
  React.useEffect(() => {
    // 如果是新用户或者没有明确选择语言，强制使用英文
    const hasUserSelectedLanguage = localStorage.getItem('userSelectedLanguage');
    if (!hasUserSelectedLanguage) {
      localStorage.setItem('i18nextLng', 'en');
    }
  }, []);

  useLanguageRouter(); // 初始化语言路由

  return (
    <HelmetProvider>
      <ThemeProvider>
        <SearchProvider>
          {/* <RedirectFix /> */}
          <SEO />
          <PerformanceOptimizer />
          <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors">
            <ScrollToTop />
            <Layout>
            <Routes>
              {/* 英文路由（默认） */}
              <Route path="/" element={<HomePage />} />
              <Route path="/tools/:category/:toolId" element={<HomePage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/sitemap" element={<SitemapPage />} />

              {/* 多语言路由 */}
              <Route path="/:lang" element={<HomePage />} />
              <Route path="/:lang/tools/:category/:toolId" element={<HomePage />} />
              <Route path="/:lang/privacy" element={<PrivacyPage />} />
              <Route path="/:lang/terms" element={<TermsPage />} />
              <Route path="/:lang/sitemap" element={<SitemapPage />} />
            </Routes>
          </Layout>
          <Toaster
            position="top-right"
            containerStyle={{
              top: '100px', // 往下移动 100px
            }}
            toastOptions={{
              duration: 3000,
              style: {
                background: 'var(--toast-bg)',
                color: 'var(--toast-color)',
                border: '1px solid var(--toast-border)',
              },
            }}
          />
          </div>
        </SearchProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
